export const getState = () => ({
  list: [],
  listPrint: [],
  listFilters: [],
  listSearch: {},
  listSort: { createdAt: 'desc' },
  listPaginate: {
    total: 0,
    perPage: 10,
    currentPage: 1,
    totalPages: 1,
    hasNextPage: false,
    hasPrevPage: false,
  },
});

export default Object.assign(getState(), { getState: getState });
